import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
  CButton,
  CRow,
  CCol,
  CFormInput,
} from "@coreui/react";

const TaoLichLamViec = ({ onSave }) => {
  const navigate = useNavigate();
  const [schedule, setSchedule] = useState(() => {
    const days = [
      "Thứ 2",
      "Thứ 3",
      "Thứ 4",
      "Thứ 5",
      "Thứ 6",
      "Thứ 7",
      "Chủ nhật",
    ];
    const shifts = ["Sáng", "Chiều", "Tối"];
    let tempData = {};
    days.forEach((day) => {
      tempData[day] = {};
      shifts.forEach((shift) => {
        tempData[day][shift] = "";
      });
    });
    return tempData;
  });

  const handleInputChange = (day, shift, value) => {
    setSchedule((prev) => ({
      ...prev,
      [day]: {
        ...prev[day],
        [shift]: value,
      },
    }));
  };

  return (
    <div>
      <h4 className="mb-3">Tạo lịch làm việc</h4>
      <CTable bordered responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell className="bg-light text-center">
              Ca làm
            </CTableHeaderCell>
            {Object.keys(schedule).map((day, index) => (
              <CTableHeaderCell
                key={index}
                className="text-center text-primary"
              >
                {day}
              </CTableHeaderCell>
            ))}
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {["Sáng", "Chiều", "Tối"].map((shift, index) => (
            <CTableRow key={index}>
              <CTableDataCell className="bg-warning text-center">
                {shift}
              </CTableDataCell>
              {Object.keys(schedule).map((day, idx) => (
                <CTableDataCell key={idx} className="text-center">
                  <CFormInput
                    type="text"
                    value={schedule[day][shift]}
                    onChange={(e) =>
                      handleInputChange(day, shift, e.target.value)
                    }
                    placeholder="Nhập tên"
                  />
                </CTableDataCell>
              ))}
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
      <CRow className="mt-3">
        <CCol className="text-end">
          <CButton
            color="primary"
            onClick={() => {
              onSave(schedule);
              navigate("/xem_lich");
            }}
          >
            Lưu & Xem Lịch
          </CButton>
        </CCol>
      </CRow>
    </div>
  );
};

export default TaoLichLamViec;
